import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import React from 'react';
import {
	TacoBellFranchiseEmptyCatalog,
	WalmartEmptyCatalog,
	GenericEmptyCatalog,
} from 'src/components/EmptyCatalog/Variants';
import { employerIds } from 'src/constants/employerResources';

export const EmptyCatalog: React.FC = () => {
	const { userFromIdToken: user } = useMemberExperienceAuth();

	if (user.employer_uuid === employerIds.walmart) {
		return <WalmartEmptyCatalog />;
	}

	if (user.employer_uuid === employerIds.tacobellFranchise) {
		return <TacoBellFranchiseEmptyCatalog />;
	}

	return <GenericEmptyCatalog />;
};
